import * as React from "react";

class OnClient extends React.Component<{ children: any }, any> {
	state = { hasRendered: false };

	componentDidMount() {
		this.setState({ hasRendered: true });
	}

	render() {
		return this.props.children(this.state.hasRendered);
	}
}

export default OnClient;
